import { useEffect, useState } from 'react';
import { permisosService } from '../services/api';
import '../styles/Clientes.css';

const Permisos = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [showPasswordPropiaModal, setShowPasswordPropiaModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [nuevoUsuario, setNuevoUsuario] = useState({
    username: '',
    nombre_completo: '',
    email: '',
    password: '',
    rol: 'cajero'
  });

  const [passwordData, setPasswordData] = useState({
    password_actual: '',
    password_nueva: '',
    password_confirmar: ''
  });

  const [passwordUsuarioData, setPasswordUsuarioData] = useState({
    password_nueva: '',
    password_confirmar: ''
  });
  const [passwordGenerada, setPasswordGenerada] = useState('');

  useEffect(() => {
    cargarUsuarios();
  }, []);

  const cargarUsuarios = async () => {
    try {
      setLoading(true);
      const response = await permisosService.getUsuarios();
      setUsuarios(response.data);
      setError(null);
    } catch (error) {
      console.error('Error al cargar usuarios:', error);
      setError('Error al cargar usuarios');
    } finally {
      setLoading(false);
    }
  };

  const handleCrearUsuario = async (e) => {
    e.preventDefault();
    try {
      await permisosService.createUsuario(nuevoUsuario);
      alert('Usuario creado exitosamente');
      setShowCreateModal(false);
      cargarUsuarios();
    } catch (error) {
      alert(error.response?.data?.error || 'Error al crear usuario');
    }
  };

  const handleCambiarRol = async (usuario, nuevoRol) => {
    try {
      await permisosService.updateRol(usuario.id, { rol: nuevoRol });
      alert('Rol actualizado exitosamente');
      cargarUsuarios();
      setShowModal(false);
    } catch (error) {
      alert('Error al cambiar rol');
    }
  };

  const handleActualizarPermisos = async () => {
    if (!selectedUser) {
      alert('Error: No hay usuario seleccionado');
      return;
    }

    if (!selectedUser.id) {
      alert('Error: El usuario no tiene un ID válido');
      console.error('Usuario sin ID:', selectedUser);
      return;
    }

    try {
      await permisosService.updatePermisos(selectedUser.id, { permisos: selectedUser.permisos });
      alert('Permisos actualizados exitosamente');
      cargarUsuarios();
      setShowModal(false);
    } catch (error) {
      alert('Error al actualizar permisos: ' + (error.response?.data?.error || error.message));
    }
  };

  const togglePermiso = (modulo, permiso) => {
    setSelectedUser(prev => {
      const nuevosPermisos = { ...prev.permisos };
      if (!nuevosPermisos[modulo]) {
        nuevosPermisos[modulo] = {};
      }
      nuevosPermisos[modulo][permiso] = !nuevosPermisos[modulo][permiso];
      return { ...prev, permisos: nuevosPermisos };
    });
  };

  const handleCambiarEstado = async (usuario) => {
    try {
      await permisosService.updateEstado(usuario.id, { activo: !usuario.activo });
      alert(`Usuario ${!usuario.activo ? 'activado' : 'desactivado'} exitosamente`);
      cargarUsuarios();
    } catch (error) {
      alert('Error al cambiar estado del usuario');
    }
  };

  const handleEliminarUsuario = async (usuario) => {
    if (!window.confirm(`¿Estás seguro de eliminar al usuario ${usuario.nombre_completo}?`)) {
      return;
    }
    try {
      await permisosService.deleteUsuario(usuario.id);
      alert('Usuario eliminado exitosamente');
      cargarUsuarios();
    } catch (error) {
      alert(error.response?.data?.error || 'Error al eliminar usuario');
    }
  };

  const handleCambiarPasswordPropia = async (e) => {
    e.preventDefault();
    
    if (passwordData.password_nueva !== passwordData.password_confirmar) {
      alert('Las contraseñas no coinciden');
      return;
    }

    if (passwordData.password_nueva.length < 6) {
      alert('La contraseña debe tener al menos 6 caracteres');
      return;
    }

    try {
      await permisosService.cambiarPasswordPropia({
        password_actual: passwordData.password_actual,
        password_nueva: passwordData.password_nueva
      });
      alert('✅ Contraseña actualizada exitosamente');
      setShowPasswordPropiaModal(false);
      setPasswordData({ password_actual: '', password_nueva: '', password_confirmar: '' });
    } catch (error) {
      alert('❌ ' + (error.response?.data?.error || 'Error al cambiar contraseña'));
    }
  };

  const generarPasswordAleatoria = (longitud = 10) => {
    const caracteres = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789@#$%';
    let resultado = '';
    for (let i = 0; i < longitud; i += 1) {
      resultado += caracteres.charAt(Math.floor(Math.random() * caracteres.length));
    }
    return resultado;
  };

  const handleGenerarPassword = () => {
    const nuevaPassword = generarPasswordAleatoria(10);
    setPasswordGenerada(nuevaPassword);
    setPasswordUsuarioData({
      password_nueva: nuevaPassword,
      password_confirmar: nuevaPassword
    });
  };

  const handleCopiarPasswordGenerada = async () => {
    if (!passwordGenerada) return;
    try {
      await navigator.clipboard.writeText(passwordGenerada);
      alert('Contraseña copiada al portapapeles');
    } catch (error) {
      console.error('No se pudo copiar la contraseña:', error);
      alert('No se pudo copiar automáticamente. Copia la contraseña manualmente.');
    }
  };

  const handleCambiarPasswordUsuario = async (e) => {
    e.preventDefault();
    
    if (!selectedUser) return;
    
    if (passwordUsuarioData.password_nueva !== passwordUsuarioData.password_confirmar) {
      alert('Las contraseñas no coinciden');
      return;
    }

    if (passwordUsuarioData.password_nueva.length < 6) {
      alert('La contraseña debe tener al menos 6 caracteres');
      return;
    }

    if (!window.confirm(`¿Cambiar la contraseña de ${selectedUser.nombre_completo}?`)) {
      return;
    }

    try {
      await permisosService.cambiarPasswordUsuario(selectedUser.id, {
        password_nueva: passwordUsuarioData.password_nueva
      });
      alert(`✅ Contraseña de ${selectedUser.username} actualizada exitosamente`);
      setShowPasswordModal(false);
      setPasswordUsuarioData({ password_nueva: '', password_confirmar: '' });
      setPasswordGenerada('');
    } catch (error) {
      alert('❌ ' + (error.response?.data?.error || 'Error al cambiar contraseña'));
    }
  };

  const getRolBadge = (rol) => {
    const colores = {
      'admin': '#e74c3c',
      'gerente': '#3498db',
      'cajero': '#27ae60',
      'cobrador': '#f39c12'
    };
    const nombres = {
      'admin': 'Administrador',
      'gerente': 'Gerente',
      'cajero': 'Cajero',
      'cobrador': 'Cobrador'
    };
    return (
      <span style={{backgroundColor: colores[rol] || '#95a5a6', color: '#fff', padding: '4px 12px', borderRadius: '4px', fontSize: '0.85rem', fontWeight: 'bold'}}>
        {nombres[rol] || rol}
      </span>
    );
  };

  if (loading) return <div className="clientes-page"><p>Cargando...</p></div>;

  return (
    <div className="clientes-page">
      <div className="clientes-header">
        <h1>🛡️ Gestión de Permisos y Usuarios</h1>
        <div style={{display: 'flex', gap: '0.5rem'}}>
          <button className="btn btn-secondary" onClick={() => setShowPasswordPropiaModal(true)}>🔑 Cambiar mi Contraseña</button>
          <button className="btn btn-primary" onClick={() => setShowCreateModal(true)}>+ Nuevo Usuario</button>
        </div>
      </div>
      {error && <div style={{padding: '1rem', background: '#fee', color: '#c33', borderRadius: '8px', marginBottom: '1rem'}}>{error}</div>}
      <div className="card">
        <div className="card-title">Usuarios del Sistema ({usuarios.length})</div>
        <div style={{overflowX: 'auto'}}>
          <table className="table">
            <thead>
              <tr>
                <th>ID</th><th>Nombre</th><th>Usuario</th><th>Email</th><th>Rol</th><th>Estado</th><th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {usuarios.map((usuario) => (
                <tr key={usuario.id}>
                  <td>{usuario.id}</td>
                  <td style={{fontWeight: 'bold'}}>{usuario.nombre_completo}</td>
                  <td>{usuario.username}</td>
                  <td>{usuario.email}</td>
                  <td>{getRolBadge(usuario.rol)}</td>
                  <td>
                    <span style={{backgroundColor: usuario.activo ? '#27ae60' : '#95a5a6', color: '#fff', padding: '4px 8px', borderRadius: '4px', fontSize: '0.85rem', cursor: 'pointer'}} onClick={() => handleCambiarEstado(usuario)}>
                      {usuario.activo ? 'ACTIVO' : 'INACTIVO'}
                    </span>
                  </td>
                  <td>
                    <button className="btn-icon" onClick={() => { 
                      console.log('Usuario seleccionado:', usuario);
                      setSelectedUser(usuario); 
                      setShowModal(true); 
                    }} title="Gestionar Permisos">🔒</button>
                    <button className="btn-icon" style={{marginLeft: '0.5rem'}} onClick={() => {
                      setSelectedUser(usuario);
                      setPasswordUsuarioData({ password_nueva: '', password_confirmar: '' });
                      setPasswordGenerada('');
                      setShowPasswordModal(true);
                    }} title="Asignar nueva contraseña">🔑</button>
                    <button className="btn-icon" style={{marginLeft: '0.5rem'}} onClick={() => handleEliminarUsuario(usuario)} disabled={usuario.id === 1} title="Eliminar Usuario">🗑️</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {showModal && selectedUser && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{maxWidth: '700px'}}>
            <div className="modal-header">
              <h2>Permisos de {selectedUser.nombre_completo}</h2>
              <button className="modal-close" onClick={() => setShowModal(false)}>×</button>
            </div>
            <div style={{padding: '2rem'}}>
              <p>Usuario: <strong>{selectedUser.username}</strong></p>
              <p>Rol actual: {getRolBadge(selectedUser.rol)}</p>
              <div style={{marginBottom: '2rem'}}>
                <label style={{display: 'block', marginBottom: '0.5rem', fontWeight: 'bold'}}>Cambiar Rol:</label>
                <select value={selectedUser.rol} onChange={(e) => handleCambiarRol(selectedUser, e.target.value)} style={{padding: '0.5rem', borderRadius: '4px', border: '1px solid #ddd', width: '100%'}}>
                  <option value="admin">Administrador</option>
                  <option value="gerente">Gerente</option>
                  <option value="cajero">Cajero</option>
                  <option value="cobrador">Cobrador</option>
                </select>
              </div>
              <h3>Permisos Asignados</h3>
              <p style={{fontSize: '0.875rem', color: '#666', marginBottom: '1rem'}}>
                Haz clic en los checkboxes para activar/desactivar permisos individuales
              </p>
              <div style={{maxHeight: '400px', overflowY: 'auto'}}>
                {selectedUser.permisos && Object.keys(selectedUser.permisos).map(modulo => (
                  <div key={modulo} style={{marginBottom: '1.5rem', padding: '1rem', background: '#f9f9f9', borderRadius: '8px'}}>
                    <h4 style={{textTransform: 'capitalize', marginBottom: '0.75rem'}}>{modulo}</h4>
                    <div style={{display: 'flex', gap: '1rem', flexWrap: 'wrap'}}>
                      {Object.keys(selectedUser.permisos[modulo]).map(permiso => (
                        <label key={permiso} style={{cursor: 'pointer', userSelect: 'none'}}>
                          <input
                            type="checkbox"
                            checked={selectedUser.permisos[modulo][permiso]}
                            onChange={() => togglePermiso(modulo, permiso)}
                            style={{marginRight: '0.5rem', cursor: 'pointer'}}
                          />
                          {permiso.charAt(0).toUpperCase() + permiso.slice(1)}
                        </label>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={handleActualizarPermisos}>Guardar Permisos</button>
            </div>
          </div>
        </div>
      )}
      {showCreateModal && (
        <div className="modal-overlay" onClick={() => setShowCreateModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{maxWidth: '600px'}}>
            <div className="modal-header">
              <h2>Crear Nuevo Usuario</h2>
              <button className="modal-close" onClick={() => setShowCreateModal(false)}>×</button>
            </div>
            <form onSubmit={handleCrearUsuario} style={{padding: '2rem'}}>
              <div style={{marginBottom: '1rem'}}>
                <label style={{display: 'block', marginBottom: '0.5rem', fontWeight: 'bold'}}>Nombre Completo *</label>
                <input type="text" required value={nuevoUsuario.nombre_completo} onChange={(e) => setNuevoUsuario({...nuevoUsuario, nombre_completo: e.target.value})} style={{width: '100%', padding: '0.5rem', borderRadius: '4px', border: '1px solid #ddd'}} />
              </div>
              <div style={{marginBottom: '1rem'}}>
                <label style={{display: 'block', marginBottom: '0.5rem', fontWeight: 'bold'}}>Nombre de Usuario *</label>
                <input type="text" required value={nuevoUsuario.username} onChange={(e) => setNuevoUsuario({...nuevoUsuario, username: e.target.value})} style={{width: '100%', padding: '0.5rem', borderRadius: '4px', border: '1px solid #ddd'}} />
              </div>
              <div style={{marginBottom: '1rem'}}>
                <label style={{display: 'block', marginBottom: '0.5rem', fontWeight: 'bold'}}>Email *</label>
                <input type="email" required value={nuevoUsuario.email} onChange={(e) => setNuevoUsuario({...nuevoUsuario, email: e.target.value})} style={{width: '100%', padding: '0.5rem', borderRadius: '4px', border: '1px solid #ddd'}} />
              </div>
              <div style={{marginBottom: '1rem'}}>
                <label style={{display: 'block', marginBottom: '0.5rem', fontWeight: 'bold'}}>Contraseña *</label>
                <input type="password" required minLength="6" value={nuevoUsuario.password} onChange={(e) => setNuevoUsuario({...nuevoUsuario, password: e.target.value})} style={{width: '100%', padding: '0.5rem', borderRadius: '4px', border: '1px solid #ddd'}} />
                <small style={{color: '#666'}}>Mínimo 6 caracteres</small>
              </div>
              <div style={{marginBottom: '1rem'}}>
                <label style={{display: 'block', marginBottom: '0.5rem', fontWeight: 'bold'}}>Rol *</label>
                <select required value={nuevoUsuario.rol} onChange={(e) => setNuevoUsuario({...nuevoUsuario, rol: e.target.value})} style={{width: '100%', padding: '0.5rem', borderRadius: '4px', border: '1px solid #ddd'}}>
                  <option value="cajero">Cajero</option>
                  <option value="cobrador">Cobrador</option>
                  <option value="gerente">Gerente</option>
                  <option value="admin">Administrador</option>
                </select>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowCreateModal(false)}>Cancelar</button>
                <button type="submit" className="btn btn-primary">Crear Usuario</button>
              </div>
            </form>
          </div>
        </div>
      )}
      {showPasswordPropiaModal && (
        <div className="modal-overlay" onClick={() => setShowPasswordPropiaModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{maxWidth: '500px'}}>
            <div className="modal-header">
              <h2>🔑 Cambiar mi Contraseña</h2>
              <button className="modal-close" onClick={() => setShowPasswordPropiaModal(false)}>×</button>
            </div>
            <form onSubmit={handleCambiarPasswordPropia} style={{padding: '2rem'}}>
              <div style={{marginBottom: '1rem'}}>
                <label style={{display: 'block', marginBottom: '0.5rem', fontWeight: 'bold'}}>Contraseña Actual *</label>
                <input 
                  type="password" 
                  required 
                  value={passwordData.password_actual} 
                  onChange={(e) => setPasswordData({...passwordData, password_actual: e.target.value})} 
                  style={{width: '100%', padding: '0.5rem', borderRadius: '4px', border: '1px solid #ddd'}} 
                  placeholder="Escribe tu contraseña actual"
                />
              </div>
              <div style={{marginBottom: '1rem'}}>
                <label style={{display: 'block', marginBottom: '0.5rem', fontWeight: 'bold'}}>Contraseña Nueva *</label>
                <input 
                  type="password" 
                  required 
                  minLength="6"
                  value={passwordData.password_nueva} 
                  onChange={(e) => setPasswordData({...passwordData, password_nueva: e.target.value})} 
                  style={{width: '100%', padding: '0.5rem', borderRadius: '4px', border: '1px solid #ddd'}} 
                  placeholder="Mínimo 6 caracteres"
                />
              </div>
              <div style={{marginBottom: '1rem'}}>
                <label style={{display: 'block', marginBottom: '0.5rem', fontWeight: 'bold'}}>Confirmar Contraseña *</label>
                <input 
                  type="password" 
                  required 
                  minLength="6"
                  value={passwordData.password_confirmar} 
                  onChange={(e) => setPasswordData({...passwordData, password_confirmar: e.target.value})} 
                  style={{width: '100%', padding: '0.5rem', borderRadius: '4px', border: '1px solid #ddd'}} 
                  placeholder="Repite la nueva contraseña"
                />
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowPasswordPropiaModal(false)}>Cancelar</button>
                <button type="submit" className="btn btn-primary">Cambiar Contraseña</button>
              </div>
            </form>
          </div>
        </div>
      )}
      {showPasswordModal && selectedUser && (
        <div className="modal-overlay" onClick={() => {
          setShowPasswordModal(false);
          setPasswordGenerada('');
        }}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{maxWidth: '520px'}}>
            <div className="modal-header">
              <h2>🔐 Asignar nueva contraseña</h2>
              <button className="modal-close" onClick={() => {
                setShowPasswordModal(false);
                setPasswordGenerada('');
              }}>×</button>
            </div>
            <form onSubmit={handleCambiarPasswordUsuario} style={{padding: '2rem'}}>
              <p style={{marginBottom: '1.25rem', fontSize: '1rem'}}>
                <strong>Usuario:</strong> {selectedUser.nombre_completo} ({selectedUser.username})
              </p>
              <div style={{display: 'flex', flexWrap: 'wrap', gap: '0.5rem', marginBottom: '1rem'}}>
                <button type="button" className="btn btn-secondary" onClick={handleGenerarPassword}>
                  ⚡ Generar contraseña segura
                </button>
                {passwordGenerada && (
                  <button type="button" className="btn btn-secondary" onClick={handleCopiarPasswordGenerada}>
                    📋 Copiar contraseña
                  </button>
                )}
              </div>
              {passwordGenerada && (
                <div style={{background: '#f0f8ff', border: '1px solid #a8d0ff', padding: '0.75rem 1rem', borderRadius: '6px', marginBottom: '1rem'}}>
                  <p style={{margin: 0}}>
                    <strong>Nueva contraseña generada:</strong>{' '}
                    <code style={{fontSize: '1.1rem'}}>{passwordGenerada}</code>
                  </p>
                  <p style={{margin: '0.5rem 0 0', fontSize: '0.85rem', color: '#2c3e50'}}>
                    Compártela con el usuario y recuérdale que la cambie en su próximo acceso.
                  </p>
                </div>
              )}
              <div style={{marginBottom: '1rem'}}>
                <label style={{display: 'block', marginBottom: '0.5rem', fontWeight: 'bold'}}>Nueva Contraseña *</label>
                <input 
                  type="password" 
                  required 
                  minLength="6"
                  value={passwordUsuarioData.password_nueva} 
                  onChange={(e) => setPasswordUsuarioData({...passwordUsuarioData, password_nueva: e.target.value})} 
                  style={{width: '100%', padding: '0.5rem', borderRadius: '4px', border: '1px solid #ddd'}} 
                  placeholder="Mínimo 6 caracteres"
                />
              </div>
              <div style={{marginBottom: '1rem'}}>
                <label style={{display: 'block', marginBottom: '0.5rem', fontWeight: 'bold'}}>Confirmar Contraseña *</label>
                <input 
                  type="password" 
                  required 
                  minLength="6"
                  value={passwordUsuarioData.password_confirmar} 
                  onChange={(e) => setPasswordUsuarioData({...passwordUsuarioData, password_confirmar: e.target.value})} 
                  style={{width: '100%', padding: '0.5rem', borderRadius: '4px', border: '1px solid #ddd'}} 
                  placeholder="Repite la nueva contraseña"
                />
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => {
                  setShowPasswordModal(false);
                  setPasswordGenerada('');
                }}>Cancelar</button>
                <button type="submit" className="btn btn-primary">Guardar nueva contraseña</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Permisos;
